import React from 'react';
import moment from 'moment';
import { DatePicker } from 'b3';
import { Icon } from 'b3';

export default class DateInput extends React.Component {
	constructor(props) {
    	super(props);

        this.state = {
            value: ('value' in props ? props.value : props.initialValue),
            showDatePicker: false,
            pickerTarget: null
        };
  	}

    componentWillReceiveProps(nextProps) {
        
        if ('value' in nextProps)
        {
            this.setState({ value: nextProps.value })
        }
        
    }

    handleOnClick(e) {
        this.props.onFocus();
        this.setState({ showDatePicker: true, pickerTarget: e.currentTarget });
    }

    handleOnCancel(e) {
        this.props.onBlur();
        this.setState({ showDatePicker: false });
    }

    handleSubmit(date) {
        var newDate = this.makeNewDateWithExistingTimeOfDay(date);

        this.setState({ showDatePicker: false, value: newDate });
        this.props.onChange(newDate);  
        this.props.onBlur();
    }

    makeNewDateWithExistingTimeOfDay = (newDate) => {
        return moment(this.state.value)
            .date(newDate.date())
            .year(newDate.year())
            .month(newDate.month());
    }

    handleOnPickDate(date) {
        var newDate = this.makeNewDateWithExistingTimeOfDay(date);
        this.setState({ 
            value: newDate
        });
      
        this.props.onChange(newDate);  
        this.props.onBlur();

        if(this.props.submitOnChangeOnly) {
            this.setState({ showDatePicker: false });
        }
    }

    getDisplayText() {
        var placeholder = this.props.placeholder ? this.props.placeholder : "n/a";
        return this.state.value
            ? this.state.value.format("D MMM YYYY")
            : placeholder;
    }

    getValue() {
        return this.state.value || moment();
    }

    handleClearValue(e) {
        this.setState({ value: null });
        this.props.onBlur();
        this.props.onChange(null);
        
        e.preventDefault();
        e.stopPropagation();
    }

    render() {
        var { submitOnChangeOnly, canCancel } = this.props;
        return (
    		<div style={{flex: 1}}>
                <div className="b3-input b3-date" style={{display: 'flex'}} onClick={ this.handleOnClick.bind(this) }>
                    <span style={{flex: 1}}>{ this.getDisplayText() }</span>
                    {canCancel &&
                        <div style={{alignItems: 'center', justifyContent: 'center', display: 'flex'}} onClick={this.handleClearValue.bind(this)}> <Icon icon="cross" /> </div>
                    }
                </div>

                
                { this.state.showDatePicker &&
                    <DatePicker 
                        position={this.props.position}
                        date={this.getValue()} 
                        onCancel={this.handleOnCancel.bind(this)}
                        onPickDate={this.handleOnPickDate.bind(this)}
                        onSubmit={submitOnChangeOnly ? null : this.handleSubmit.bind(this)}
                        target={this.state.pickerTarget} />
                }
            </div>
        );
    }
}

DateInput.defaultProps = {
    initialValue : moment(),
    onChange: function() {},
    onFocus: function() {},
    onBlur: function() {},
    canCancel: true
};



// WEBPACK FOOTER //
// ./app/b3/inputs/DateInput.js